import { SignInNotice } from '@talbenmoshe/trip-os-model';
const SIGNED_OUT_REASON = 'signed-out';
/** Only a sign-out has a notice ("You’ve signed out"); any other reason, or none, opens the plain screen. */
export class ArrivalNoticeResolver {
    resolve(arrivalReason) {
        return arrivalReason === SIGNED_OUT_REASON ? SignInNotice.SIGNED_OUT : SignInNotice.NONE;
    }
}
//# sourceMappingURL=ArrivalNoticeResolver.js.map